import { AppLayout, Container, ContentLayout, FormField, Header, Input, SpaceBetween, Link } from '@amzn/awsui-components-react';
import React from 'react';
import { Navigation } from '../../components';
import { getBreadcrumbItemsFromCourse } from '../../common';
import { useAuthContext } from '../../components/auth/AuthContext';
import { Breadcrumbs } from '../../components';

export const Profile = () => {
    const { user } = useAuthContext();
    const Content = () => {
        return (
            <ContentLayout
                header={
                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Header variant='h2' description='Personal Information'>
                            Profile
                        </Header>
                        <div style={{ marginLeft: 'auto', whiteSpace: 'nowrap', marginTop: '28px' }}>
                            <Link href='https://skillbuilder.aws/my-profile' external target='_blank'>
                                Edit my profile
                            </Link>
                        </div>
                    </div>
                }
            >
                <Container>
                    <SpaceBetween size='s'>
                        <FormField label='First Name'>
                            <Input value={user.firstName ?? ''} disabled={true} />
                        </FormField>
                        <FormField label='Last Name'>
                            <Input value={user.lastName ?? ''} disabled={true} />
                        </FormField>
                        <FormField label='Email'>
                            <Input value={user.email ?? ''} disabled={true} />
                        </FormField>
                        <FormField label='Organization'>
                            <Input value={user.organization ?? ''} disabled={true} />
                        </FormField>
                    </SpaceBetween>
                </Container>
            </ContentLayout>
        );
    };

    return (
        <AppLayout
            content={<Content />}
            navigation={<Navigation />}
            toolsHide={true}
            breadcrumbs={<Breadcrumbs items={getBreadcrumbItemsFromCourse('Profile')} />}
        />
    );
};

export default Profile;
